//This is a template for the deeper look page

import { useState } from "react";
import DeeperLookIcon_Trans from "../../../assets/UI/DeeperLookIcon_Trans.png";
import HeaderNavNTM from "../../../Components/Header/Header_Nav_NoBottomMargin/Header_Nav_NBM";
import "../DeeperLook.css"; //will be used globally

export default function ColorsDLook() {
    //array for storing text input
    //defines type and content so they can be processed later
const categories = {
    Colors_DL_Overview: {

        title: "Overview",
        content:[
                { type: "subheader", content: "Introduction" },
                { type: "paragraph", content: "Colors are an important part of everyday conversation in Korean. Whether you’re describing clothes, food, or the world around you, knowing color vocabulary helps you sound more natural and expressive. In Korean, colors can be used both as nouns (naming the color itself) and as adjectives (describing something with that color). Some colors are based on pure Korean words, while others are borrowed from Chinese characters or modern usage. This deck will help you build confidence in recognizing and using colors in different contexts." },
                { type: "paragraph", content: "Colors in Korean are simple to learn, and many of them follow clear patterns. Here are the most common and useful colors to get started:"},
                { 
                    type: "table", 
                    rows: [
                        ["Term", "Definition"],
                        ["빨강 (ppal-gang)", "Red"],
                        ["파랑 (pa-rang)", "Blue"],
                        ["노랑 (no-rang)", "Yellow"],
                        ["초록 (cho-rok)", "Green"],
                        ["하양 (ha-yang)", "White"],
                        ["검정 (geom-jeong)", "Black"]
                    ]
                },
                { type: "paragraph", content: "These forms are often used as nouns. For example, 파랑 means “blue” (the color itself). Later, you’ll learn how to use them as adjectives to describe objects."},
                { type: "paragraph", content: "Try practicing by looking around you and naming objects with these colors in Korean!"}
            
            ]
    },
        

    Colors_DL_Subject1:{
        
        title: "Colors in Sentences",
        content:[    
            { type: "subheader", content: "Nouns vs. Adjectives" },
            { type: "paragraph", content: "In Korean, colors can change form depending on how you use them. The difference is whether you’re talking about the color as a thing (noun) or as a description (adjective)." },
            
            { type: "subheader", content: "Colors as Nouns" },
            { type: "paragraph", content: "Noun form: talking about the color itself." },
            { type: "list", items: [
                "파랑 좋아해요. → I like blue.", 
                "하양 좋아해요. → I like white.", 
                "빨강  좋아해요. → I like red."
                ] 
            },
            { type: "subheader", content: "Colors as Adjectives" },
            { type: "paragraph", content: "Adjective form: describing something with that color." },
            { type: "list", items: [
                "빨간 사과.  → Red apple.", 
                "노란 바나나. → Yellow Banana.", 
                "하얀 눈. → White snow."
                ] 
            },

            { type: "paragraph", content: "Here are a few common changes to watch for:" },
            { type: "list", items: 
                [
                "빨강 → 빨간 (red)", 
                "파랑 → 파란 (blue)", 
                "노랑 → 노란 (yellow)",
                "초록 → 초록 (green, often used directly)",
                "하양 → 하얀 (white)",
                "검정 → 검은 (black, also 검정 can be used directly)"
                ] 
            },

            { type: "paragraph", content: "Don’t worry too much about memorizing the pattern right away. Practice will make it feel natural!" },
           
           { type: "subheader", content: "Try It Yourself!" },
            { type: "paragraph", content: "Try making simple sentences like:" },
            { type: "list", items: 
                [
                "빨간 꽃이에요. → It’s a red flower.",
                "하얀 눈이에요. → It’s white snow."
                ] 
            },
        ]
    },

    Colors_DL_Subject2: {
    
        title: "Everyday Examples",
        content:[    
            { type: "subheader", content: "Common Uses" },
            { type: "paragraph", content: "Colors appear all around us in daily life, so practicing them in context helps you remember them better. Here are some common ways to use colors in everyday situations:" },
            { type: "paragraph", content: "Clothing:" },
            { type: "list", items: 
                [
                "파란 셔츠 → a blue shirt",
                "빨간 드레스 → a red dress"
                ] 
            },
            { type: "paragraph", content: "Food:" },
            { type: "list", items: 
                [
                "노란 바나나 → a yellow banana",
                "초록 사과 → a green apple"
                ] 
            },
            { type: "paragraph", content: "Nature:" },
            { type: "list", items: 
                [
                "파란 하늘 → a blue sky",
                "초록 잎 → green leaves",
                "하얀 꽃 → white flowers"
                ] 
            },
            { type: "subheader", content: "Try It Yourself!" },
            { type: "paragraph", content: "Look around you and try naming 3 things in your environment with their colors in Korean. This small exercise makes colors stick naturally!" }
        ]
    },
    
    Colors_DL_Subject3: {
        title: "Variations & Shades",
        content:[
            { type: "subheader", content: "Shades" },
            { type: "paragraph", content: "Korean colors can be adjusted to show lighter or darker shades, which makes your descriptions more precise and natural. You do this by adding small words before the color:" },
            { type: "paragraph", content: "연- (yeon-) → light/pale" },
            { type: "list", items: 
                [
                "연두 → light green",
                "초록 잎 → green leaves",
                "연노랑 → light yellow",
                "연분홍 → light pink",
                "연보라 → light purple",
                "연파랑 → light blue",
                "연한 갈색 → light brown"
                ] 
            },
            { type: "paragraph", content: "진- (jin-) → deep/dark" },
            { type: "list", items: 
                [
                    "진파랑 → deep blue",
                    "진빨강 → deep red",
                    "진초록 → deep green",
                    "진보라 → deep purple",
                    "진분홍 → deep pink",
                    "진한 노랑 → deep yellow",
                    "진한 주황 → deep orange",
                    "진한 갈색 → deep brown",
                    "진한 회색 → deep gray"
                ] 
            },
            
            { type: "subheader", content: "Variations" },
            { type: "paragraph", content: "Some other variations are common in everyday speech:" },
            { type: "list", items: 
                [
                    "하늘색 (ha-neul-saek) → sky blue",
                    "밤색 (bam-saek) → brown (literally “night color”)",
                ] 
            },

            { type: "subheader", content: "Try it Yourself!" },
            { type: "paragraph", content: "Practicing shades helps you sound more natural and descriptive when talking about clothes, food, or scenery. For example:" },
            { type: "list", items: 
                [
                    "연초록 잎 → a light green leaf",
                    "진하늘 하늘 → a deep blue sky",
                ] 
            }


        ]
    }
}


  //Make overveiw the default catgory selected when page loads
  const [selectedCategory, setSelectedCategory] = useState("Colors_DL_Overview");


  return (
    <div>
      
      <HeaderNavNTM GoBack_to="/ColorsNav"/>

      <div className="blue-header-dlook">
        <img
          className="DeeperLookImage-dlook"
          src={DeeperLookIcon_Trans}
          alt="Deeper Look"
        />
      </div>
      {/* End of blue header */}




      {/* Body */}
      <div className="panel-container-dlook">
        
        
        
        {/* Side panel */}
        <div className="side-panel-dlook">
          {Object.keys(categories).map(key => (
            //iterates over the properties (keys) of an object to produce a new array
            
            <p
              key={key}
                //key is a special attribute required by React when rending a list of elements
                    
              className={key === selectedCategory 
                ? "category-active" 
                : "category-inactive"}
          
              onClick={() => setSelectedCategory(key)}    
            
            >

                    
              {categories[key].title}
            </p>
          ))}
        </div>

        {/* Text panel */}
    <div className="text-panel-dlook">
       {(categories[selectedCategory]?.content ?? []).map((item, index) => {
  // your switch logic here

           
           //(categories[selectedCategory] ?? [])
                //ccesses the catgories object using the variable 'selectedCategory' as the key
                //retreives specific array of cintent items that belongs to the currently active category
                // ?? []
                    //?? --> nullish coalescing operator
                        //provides fallback
                        //if categories[selectedCategory] is null or undefined (no category selected), then
                            //defaults to an empty array []
                            //this prevents application from crashing + ensures map method is called safely

        //.map((item, index) => ... ): 
             //array method iterates over each item in the array, returns a new array of JSX elements.

           switch (item.type) {
                //switch statement checks the value of item.type for each item
                    //allows components to render different html elements based on the data's type
           
           //if item.type is "subheader", return <h> element
            case "subheader":
                return <h3 key={index} className="subheader-dlook">{item.content}</h3>;
                //key={index}--> unquie key prop assigned to help react efficeintly update list of elements

            case "paragraph":
                return <p key={index}>{item.content}</p>;
                //{item.content}--> displays text content for the 'paragraph'

            case "list":
                return (
                <ul key={index} className="list-dlook">
                    {item.items.map((bullet, i) => (
                    <li key={i}>{bullet}</li>
                    ))}
                </ul>
                );
            //<ul> --> unordered list html element

            case "table":
                return (
                <table key={index} className="table-dlook">
                    <tbody>
                    {item.rows.map((row, r) => (
                        <tr key={r}>
                        {row.map((cell, c) => (
                            <td key={c}>{cell}</td>
                        ))}
                        </tr>
                    ))}
                    </tbody>
                </table>
                );
                //{item.rows.map((row, r) => ... )}
                    //iterates over the rows property of the current item object
                    //for each element in the rows array, it return a <tr> (table row) element
                    //key={r}--> provides unique key for each row
                //{row.map((cell, c) => ... )}
                    //executed for every row and iterates over the array of cell data within that row.
                    //for each element, returns <td> (table data) element -->cell in the table

            default:
                return null;
            //handles any item.type that doesnt match defined case
            //return null tells react to render nothing
            }
            })}
        </div>

      </div>
     
      {/* End Body */}
    
    
    
    </div>
  );/* End return */
} //End function


//Resources
    //Rendering Components Inside a Loop
        //https://www.youtube.com/watch?v=8AY4siDB3ow
